import { useQuery } from "@tanstack/react-query";
import axios from "axios";


const WEBHOOK_URL = 'https://n8n.rvcarbon.com.br/webhook/history';

export function useChatHistory(sessionId: string) {
    return useQuery({
        queryKey: ['chat', sessionId],
        queryFn: async () => {
            const response = await axios.get(WEBHOOK_URL, {
                params: {
                    sessionId,
                },
            });

            return response.data;
        },

    });
}